import { randomId } from '@shared/utils/guid.js'

export const getInstallationId = () => {
  let id = localStorage.getItem('installation_id')

  if (id != null) {
    return id
  }

  id = randomId()
  localStorage.setItem('installation_id', id)
  return id
}
